import { apiErrorCode, apiErrorMessage } from '../../../api/coLiving/errors';

// The refusals a status step can get, in words. Shared by the ticket detail
// and the status menu in the list, so both say the same thing.
const KNOWN = {
  tenant_note_contains_contact: 'CO_LIVING.TICKETS.NOTES.ERRORS.CONTACT',
  reason_required: 'CO_LIVING.TICKETS.STEP_MODAL.REASON_REQUIRED',
  future_visit_booked: 'CO_LIVING.TICKETS.FUTURE_VISIT_BOOKED',
};

// Why a status cannot be set now ("Book a visit first"), from the code the
// server gave in `blocked_statuses`.
export function blockedReason(vm, code) {
  const key = `CO_LIVING.TICKETS.SET_STATUS.BLOCKED.${String(
    code
  ).toUpperCase()}`;
  return vm.$te(key) ? vm.$t(key) : String(code).replace(/_/g, ' ');
}

// `vm` is the component (for $t). Answers { code, message }; `code` lets the
// caller refresh stale buttons on step_not_allowed.
export function stepFailure(vm, err) {
  const code = apiErrorCode(err);
  const message = KNOWN[code]
    ? vm.$t(KNOWN[code])
    : apiErrorMessage(vm, err, 'CO_LIVING.TICKETS.STEP_FAILED');
  return { code, message };
}
